import {Button, Typography} from "@mui/material"
import Grid from "@mui/material/Grid"
import {TextToHTML} from "@indebted/components/TextToHTML"
import {useState} from "react"
import {useNotification} from "@indebted/components/Notification"

function CPAConfirmationDialog({
	modal,
	onCancel,
	onSubmitCPA,
	i18n,
	secureCode,
	stripe,
	debitCardElement,
	form,
	providerData,
	paymentPlanID,
	paymentMethod,
	last4CardDigits,
}) {
	const {notification} = useNotification()
	const [disabled, setDisabled] = useState(false)
	const [disableBackdropClick, setDisableBackdropClick] = useState(false)
	const [disableEscapeKeyDown, setDisableEscapeKeyDown] = useState(false)

	const submitButtonClicked = (event) => {
		event.preventDefault()

		setDisabled(true)
		setDisableBackdropClick(true)
		setDisableEscapeKeyDown(true)

		return onSubmitCPA(
			{
				secureCode,
				stripe,
				debitCardElement,
				form,
				providerData,
				paymentPlanID,
				notification,
				i18n,
				paymentMethod,
			}, // TODO: rename to stripePaymentMethod
		).catch(() => {
			setDisabled(false)
			setDisableBackdropClick(false)
			setDisableEscapeKeyDown(false)

			onCancel()
			modal.Close()
		})
	}

	const cancelButtonClicked = (event) => {
		event.preventDefault()

		setDisabled(false)
		setDisableBackdropClick(false)
		setDisableEscapeKeyDown(false)

		onCancel()
		modal.Close()
	}

	return (
		<modal.Component
			style={{width: "100%"}}
			disableBackdropClick={disableBackdropClick}
			disableEscapeKeyDown={disableEscapeKeyDown}
		>
			<Grid container direction="column" spacing={3}>
				<Grid
					container
					direction="row"
					spacing={3}
					style={{alignItems: "center", justifyContent: "flex-start"}}
				>
					<Grid size={{xs: 9, sm: 10}} style={{paddingLeft: "12px", paddingTop: "18px"}}>
						<Typography variant="subtitle1" style={{fontWeight: "bold", lineHeight: 1.3}} align="left">
							{i18n.CPAModalTitle}
						</Typography>
					</Grid>
					<Grid size={{xs: 3, sm: 2}} style={{display: "flex", justifyContent: "flex-end"}}>
						<modal.CloseIconButton disabled={disabled} />
					</Grid>
				</Grid>
				<Grid style={{paddingLeft: "6px"}}>
					<TextToHTML text={i18n.CPAModalText?.replace("${last4CardDigits}", last4CardDigits)} />
				</Grid>
				<Grid>
					<Button fullWidth type="submit" onClick={submitButtonClicked} disabled={disabled}>
						{i18n.CPAModalPrimaryButtonLabel}
					</Button>
				</Grid>
				<Grid>
					<Button fullWidth variant="outlined" onClick={cancelButtonClicked} disabled={disabled}>
						{i18n.CPAModalSecondaryButtonLabel}
					</Button>
				</Grid>
				<Grid>
					<Typography color="textSecondary">
						<TextToHTML text={i18n.CPAModalConditionText} />
					</Typography>
				</Grid>
			</Grid>
		</modal.Component>
	)
}

export {CPAConfirmationDialog}
